module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACoSURBVHgB1dNBCsMgEAXQ6SCuc5ReoTfoJURc9gQxN+hOxIVHyBVyLFe2M9BFKWkymlUGRHHwIXwG4BSVcx5ijPeWN7h2WUq50janlEY4AjnnllrrRMtLsctWM4TgEXGk5Y0xUzfUgu1CUkwEfWN0fFhrn799lEJKqRfvFMAAvT/i5DhBTpIS9V2QBNmFpMgm1IL8hT5zNksRLrV2qbVeaN5uPCpw2noDDf9nfgsRzi0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/mb4.png
// module id = NNBI
// module chunks = 25